
<div role="region">
  <row>
    <div class="left-panel">
      <ol class="breadcrumbs" aria-label="breadcrumb">
        <slot name="crumbs"></slot>
      </ol>
    </div>
    <slot name="modal"></slot>
    <slot name="action"></slot>
  </row>
</div>
